import { TableRow } from "@/components/ui/table";
import { CompetitiveMetricRow } from "../CompetitiveMetricRow";
import { PageRankBar } from "../PageRankBar";
import { URLAnalysis } from "@/types/seo";

interface AuthorityMetricsProps {
  urlAnalyses: URLAnalysis[];
}

export const AuthorityMetrics = ({ urlAnalyses }: AuthorityMetricsProps) => (
  <>
    <CompetitiveMetricRow
      label="PageRank"
      description="Pontuação que indica a autoridade da página, calculada com base em diversos fatores."
      analyses={urlAnalyses}
      getValue={(analysis) => {
        const score = analysis.semrush?.backlinks?.ascore || 0;
        return Math.ceil(score);
      }}
      renderValue={(value) => {
        const score = typeof value === 'number' ? value : 0;
        return (
          <div className="flex justify-center">
            <PageRankBar 
              score={score} 
              rawScore={score}
            />
          </div>
        );
      }}
      getBestMetric={(value, bestValue) => {
        const pagerank = typeof value === 'number' ? value : 0;
        return pagerank > bestValue;
      }}
    />

    <CompetitiveMetricRow
      label="Domínios de Referência"
      description="Quantidade de domínios únicos que apontam links para a página."
      analyses={urlAnalyses}
      getValue={(analysis) => {
        const domains = analysis.semrush?.backlinks?.domains_num || analysis.backlinks || 0;
        return domains;
      }}
      getBestMetric={(value, bestValue) => {
        const domains = typeof value === 'number' ? value : 0;
        return domains > (bestValue || 0);
      }}
    />

    <CompetitiveMetricRow
      label="Backlinks"
      description="Quantidade total de links apontando para a página."
      analyses={urlAnalyses}
      getValue={(analysis) => {
        const backlinks = analysis.semrush?.backlinks?.urls_num || 0;
        return backlinks;
      }}
      getBestMetric={(value, bestValue) => {
        const backlinks = typeof value === 'number' ? value : 0;
        return backlinks > (bestValue || 0);
      }}
    />
  </>
);